'use client';

import { SortDirection } from '@/enums/sort';
import clsx from 'clsx';
import type { FC } from 'react';

const SORT_ACTIVE_CLASS = 'text-[#1677ff]';
const SORT_IDLE_CLASS = 'text-slate-300';

type SortCaretProps = {
    direction: 'up' | 'down';
    active: boolean;
};

const SortCaret: FC<SortCaretProps> = ({ direction, active }) => (
    <svg
        viewBox="0 0 8 6"
        aria-hidden="true"
        data-sort-caret={direction}
        data-active={active ? 'true' : 'false'}
        className={clsx(
            'h-[6px] w-[8px]',
            direction === 'down' && 'rotate-180',
            active ? SORT_ACTIVE_CLASS : SORT_IDLE_CLASS,
        )}
    >
        <path
            d="M1 4.5L4 1.5L7 4.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export type SortProps = {
    value?: SortDirection;
};

const Sort: FC<SortProps> = ({ value = SortDirection.NONE }) => (
    <span
        aria-hidden="true"
        data-sort-direction={value}
        className="pointer-events-none mt-px inline-flex select-none flex-col items-center justify-center gap-px"
    >
        <SortCaret direction="up" active={value === SortDirection.ASC} />
        <SortCaret direction="down" active={value === SortDirection.DESC} />
    </span>
);

export default Sort;
